import { apiClient } from './api';

interface ContactData {
  // Add specific contact fields as needed
  [key: string]: any;
}

interface UserData {
  // Add specific user fields as needed
  [key: string]: any;
}

export interface ScheduledMessage {
  id: string;
  tenant_id: string;
  user_id: string;
  channel_type: string;
  channel_value: string;
  msg_data: string;
  send_at: string;
  created_dt: string;
  updated_dt: string;
  celery_task_id: string;
  send_to: string;
  user_timezone: string;
  user_data: UserData;
  msg_key: string;
  was_sent: boolean;
  contact_data: ContactData;
  metadata: any;
}

interface ScheduledMessagesResponse {
  results: ScheduledMessage[];
  success: boolean;
  status: number;
}

export const messageService = {
  getScheduledMessages: async (sendTo?: string): Promise<ScheduledMessagesResponse> => {
    const params = sendTo ? { send_to: sendTo } : undefined;
    const response = await apiClient.get('/messages/schedule', { params });
    return response.data;
  },
};

export default messageService; 